// extracted by mini-css-extract-plugin
export var alignBaseline = "_h-9";
export var alignCenter = "_h-5";
export var alignFlexEnd = "_h-7";
export var alignFlexStart = "_h-6";
export var alignSelfBaseline = "_h-e";
export var alignSelfCenter = "_h-a";
export var alignSelfFlexEnd = "_h-c";
export var alignSelfFlexStart = "_h-b";
export var alignSelfStretch = "_h-d";
export var alignStretch = "_h-8";
export var column = "_h-2";
export var columnReverse = "_h-4";
export var flex = "_h-0";
export var justifyCenter = "_h-f";
export var justifyFlexEnd = "_h-h";
export var justifyFlexStart = "_h-g";
export var justifySpaceAround = "_h-j";
export var justifySpaceBetween = "_h-i";
export var justifySpaceEvenly = "_h-k";
export var row = "_h-1";
export var rowReverse = "_h-3";
export var wrapNowrap = "_h-m";
export var wrapWrap = "_h-l";
export var wrapWrapReverse = "_h-n";